import { i18n } from 'next-i18next'
import { makeOrderFrequencyInitialState } from 'modules/order/state/frequency/order-frequency-utils'
import { FlowStep } from '../../flow-types'
import { INITIAL_INVALID_STEP_INDEX, INITIAL_NUM_VISITS } from './constants'
import { Config } from 'modules/config/state/config-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { getOrderAmountInitialState } from 'modules/order/state/amount/order-amount-utils'
import { RECURRING_NUDGE_THRESHOLD } from '../../flow-middlewares'

export const RECURRING_NUDGE_STEP_NAME = 'recurring-nudge'

const makeRecurringNudgeStep = (config: Config, urlParams: URLParams): FlowStep => {
  const t = i18n?.t.bind(i18n) || ((key: string, fallback: string) => fallback)
  let enabled = config.recurringNudge.enabled

  if (enabled) {
    const initialOrderFrequencyState = makeOrderFrequencyInitialState(config, urlParams)
    const initialAmount = getOrderAmountInitialState(config, urlParams).value
    const amountIsMoreThanThreshold = initialAmount > RECURRING_NUDGE_THRESHOLD

    if (initialOrderFrequencyState.value === 'monthly' || amountIsMoreThanThreshold) {
      enabled = false
    }
  }

  return {
    name: RECURRING_NUDGE_STEP_NAME,
    title: t('RecurringNudgeStep', 'Become a monthly supporter!'),
    enabled,
    index: INITIAL_INVALID_STEP_INDEX,
    numVisits: INITIAL_NUM_VISITS,
    layout: 'flow-two-column',
  }
}

export default makeRecurringNudgeStep
